import React from 'react';
import styles from './LandingForm.module.scss';
import HeroBannerPreview from './ComponentTypesPreviews/HeroBannerPreview';
import MarkdownPreview from './ComponentTypesPreviews/MarkdownPreview';
import YoutubeVideoPreview from './ComponentTypesPreviews/YoutubeVideoPreview';
import BannerPreview from './ComponentTypesPreviews/BannerPreview';
import CardGridPreview from './ComponentTypesPreviews/CardGridPreview';
import FaqPreview from './ComponentTypesPreviews/FAQPreview';
import WebinarPreview from './ComponentTypesPreviews/WebinarPreview';
import ContentGridPreview from './ComponentTypesPreviews/ContentGridPreview';
import NewsletterBannerPreview from './ComponentTypesPreviews/NewsletterBannerPreview';
import SearchBarPreview from './ComponentTypesPreviews/SearchBarPreview';
import TestimonialPreview from './ComponentTypesPreviews/TestimonialPreview';
import HtmlOuterScriptPreview from './ComponentTypesPreviews/HtmlOuterScriptPreview';
import HtmlInnerScriptPreview from './ComponentTypesPreviews/HtmlInnerScriptPreview';
import { TitlePreview } from './ComponentTypesPreviews/TitlePreview';
import { LandingComponent } from 'app/types';
import GenericFormPreview from './ComponentTypesPreviews/GenericFormPreview';

interface PreviewComponentProps {
  landing_cmp: LandingComponent;
}

const ComponentPreview = ({ landing_cmp }: PreviewComponentProps): React.ReactElement => {
  const sectionSizeStyle = (size?: string) => {
    if (size === 'sm') return `container ua-cms__container--small`;
    else if (size === 'md') return 'container';
    else return '';
  };
  const sectionGapStyle = (gap?: string) => {
    if (gap === 'lg') return 'my-5';
    else if (gap === 'md') return 'my-3';
    else if (gap === 'sm') return 'my-1';
    else return 'my-0';
  };
  const sectionComponent = (type?: string) => {
    switch (type) {
      case 'hero_banner':
        return <HeroBannerPreview landing_cmp={landing_cmp} />;
      case 'markdown':
        return <MarkdownPreview landing_cmp={landing_cmp} />;
      case 'youtube_video':
        return <YoutubeVideoPreview landing_cmp={landing_cmp} />;
      case 'banner':
        return <BannerPreview landing_cmp={landing_cmp} />;
      case 'card_grid':
        return <CardGridPreview landing_cmp={landing_cmp} />;
      case 'faq':
        return <FaqPreview landing_cmp={landing_cmp} />;
      case 'webinar':
        return <WebinarPreview landing_cmp={landing_cmp} />;
      case 'content_grid':
        return <ContentGridPreview landing_cmp={landing_cmp} />;
      case 'newsletter_banner':
        return <NewsletterBannerPreview landing_cmp={landing_cmp} />;
      case 'search_bar':
        return <SearchBarPreview landing_cmp={landing_cmp} />;
      case 'testimonial':
        return <TestimonialPreview landing_cmp={landing_cmp} />;
      case 'title':
        return <TitlePreview landing_cmp={landing_cmp} isStandalone={true} />;
      case 'html_inner_script':
        return <HtmlInnerScriptPreview landing_cmp={landing_cmp} />;
      case 'html_outer_script':
        return <HtmlOuterScriptPreview landing_cmp={landing_cmp} />;
      case 'form':
        return <GenericFormPreview landing_cmp={landing_cmp} />;
        break;
      default:
    }
  };
  return (
    <section
      id={landing_cmp.html_id}
      key={landing_cmp.id}
      className={`ua-cms__${landing_cmp.component_type} container-fluid ${
        landing_cmp.class_name
      } ${sectionGapStyle(landing_cmp.gap)} ${styles.cms}`}
      style={{
        background: !(landing_cmp.background instanceof File) ? landing_cmp.background : 'auto',
        backgroundImage: `url(${landing_cmp.background_image})`,
      }}
    >
      <div className={`${sectionSizeStyle(landing_cmp.size)}`}>
        {sectionComponent(landing_cmp.component_type)}
      </div>
    </section>
  );
};

export default ComponentPreview;
